/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2021-12-21 10:21:40
 *
 *******************************************************/
//flow
import React, { Component } from 'react';
import { Stack, RadioButton, FormLayout } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Field } from 'redux-form';

import { RenderTextField } from 'src/components/views/common/forms/render-textfield';
import { RenderChoice } from 'src/components/views/common/forms/render-choice';
import { buildOptionList } from 'src/helpers';

type Props = { option: number, removeAll: boolean };

type ComposedProps = Props & WithI18nProps;
// DONE
class OptionFeedback extends Component<ComposedProps> {

  render() {
    const { i18n, option, removeAll } = this.props;
    const suffixType = removeAll === true ? 'All' : 'Search';

    const listOption = buildOptionList([
      { value: 'Yes', label: 'AdminHTML.ThemeSetup.FeedbackModal.yes' },
      { value: 'No', label: 'AdminHTML.ThemeSetup.FeedbackModal.no' },
    ], i18n);

    return (
      <div className="BC-Page__Installation__OptionFeedback feedback-form">
        <Stack vertical>
          <RadioButton
            label={i18n.translate(
              `AdminHTML.ThemeSetup.FeedbackModal.option${option}_${suffixType}_RadioButton_Label`
            )}
            checked={true}
            id={option}
            name="options"
          />
          <div style={{ marginLeft: '1.75rem' }}>
            <FormLayout>
              <p style={{ marginTop: '-1rem' }}>
                {i18n.translate(
                  `AdminHTML.ThemeSetup.FeedbackModal.option${option}_${suffixType}_Paragraph`
                )}
              </p>
              {
                removeAll && option === 3 ?
                <Stack vertical>
                  <Field
                    name="optionsQuestion2"
                    component={RenderChoice}
                    choices={listOption}
                  />
                </Stack> : 
                <>
                  <Field
                    name="content"
                    label={i18n.translate(`AdminHTML.ThemeSetup.FeedbackModal.option_Content`)}
                    component={RenderTextField}
                    anotherProps={{ multiline: 5 }}
                  />
                </>
              }
            </FormLayout>
          </div>
        </Stack>
      </div>
    );
  }
}

export default withI18n()(OptionFeedback);
